import { Box } from "@mui/material";
import styled from "styled-components";

export const AdminCardTopContainer = styled(Box as any)`
  padding-bottom: 4px;
  display: flex;
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

export const RightContainer = styled.div`
  width: 70px;
  flex-direction: row;
  align-items: end;
`;

export const StatusContainer = styled.div`
  align-items: end;
  align-content: end;
  align-self: flex-end;
  flex-direction: row;
  text-align: end;
`;
